import { type Enum } from '@webapp/infrastructure/types/Enum'

export const OrderItemStatuses = {
  PENDING: null,
  PENDING_PURCHASE: 1,
  APPROVED: 0,
  PURCHASED: 2,
  RECEIVED: 3,
  REJECTED: 4,
  PARTIALLY_RECEIVED: 5,
  DENIED: 7,
  DRAFT: 8,
} as const

export type OrderItemStatusEnum = Enum<typeof OrderItemStatuses>
